import { NgModule } from '@angular/core';
import { TimeLimitShapeService } from './time-limit-shape.service';
import { TimeLimitHandleService } from './time-limit-handle.service';
import { TimeLimitHingeService } from './time-limit-hinge.service';
import { TimeLimitLockService } from './time-limit-lock.service';
import { TimeLimitFittingService } from './time-limit-fitting.service';
import { TimeLimitProfileService } from '@icc/construction-elements/configurator';
import { TimeLimitSystemService } from './time-limit-system.service';
import { TimeLimitFillingService } from './time-limit-filling.service';
import { TimeLimitSealColorService } from './time-limit-seal-color.service';

@NgModule({
    providers: [
        TimeLimitShapeService,
        TimeLimitHandleService,
        TimeLimitHingeService,
        TimeLimitLockService,
        TimeLimitFittingService,
        TimeLimitProfileService,
        TimeLimitSystemService,
        TimeLimitFillingService,
        TimeLimitSealColorService,
    ],
})
export class WindowDoorTimeLimitModule {}
